import isWrappedBy from './is-wrapped-by';
import isWrapperRegistered from './is-wrapper-registered';
import customColors from './custom-colors';

export default {
  ...customColors,
  isWrappedBy,
  isWrapperRegistered,
};
